exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-dialog-actions .mat-button,\n.mat-dialog-actions .mat-raised-button {\n  width: 50%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Source/Ecim/Ecim.Web/src/app/components/cancel-application/cancel-application.component.scss
// module id = ../../../../../src/app/components/cancel-application/cancel-application.component.scss
// module chunks = main